module.exports = __webpack_public_path__ + "img/38_75.ad3192bd.png";